import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {UtilService} from '../../../services/util.service';
import {UiBlockerService} from '../../../services/ui-blocker.service';
import {map} from 'rxjs/operators';
import {SourcingMatrixService} from '../../../services/sourcing-matrix.service';
import {SourcingMatrixReport} from '../../../models/sourcing-matrix-report.model';

@Injectable({providedIn: 'root'})
export class SourcingMatrixResolver implements Resolve<Observable<Array<SourcingMatrixReport>>> {

  constructor(private service: SourcingMatrixService, private utilService: UtilService, private uiBlockerService: UiBlockerService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<SourcingMatrixReport>> {
    this.uiBlockerService.block();
    const projectId = this.utilService.getRouteParameter(route, 'projectId');
    const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
    return this.service.fetchAll(+projectId, modelRunId).pipe(map((reports: SourcingMatrixReport[]) => {
      this.uiBlockerService.unblock();
      return reports;
    }));
  }
}
